import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle, X } from "lucide-react";
import { cn } from "@/lib/utils";

export const UsageWarningBanner = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [w, setW] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("d20-usage-warn-dismissed"));

  const uid = user?.id;
  useEffect(() => {
    if (!uid) return;
    api.get("/billing/usage-warning").then((r) => setW(r.data.warning)).catch(() => {});
  }, [uid, pathname]);

  if (!w || hidden === w.at || pathname === "/billing") return null;
  const full = w.threshold >= 100;
  return (
    <div data-testid="usage-warning-banner" data-threshold={w.threshold} className={cn("border-b px-4 py-2 text-sm flex flex-wrap items-center justify-center gap-3", full ? "border-red-500/40 bg-red-500/10" : "border-amber-500/40 bg-amber-500/10")}>
      <AlertTriangle className={cn("h-4 w-4", full ? "text-red-500" : "text-amber-500")} />
      <span><strong>{w.title}.</strong> {w.message}</span>
      {user.role === "admin" && <Button size="sm" variant="outline" data-testid="usage-warning-upgrade" onClick={() => navigate("/billing")}>View usage & upgrade</Button>}
      <button data-testid="usage-warning-dismiss" onClick={() => { sessionStorage.setItem("d20-usage-warn-dismissed", w.at); setHidden(w.at); }} className="text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
};
